module.exports = __webpack_public_path__ + "3468a16957f6585e3604a402bac2260f.png";